import posthog from "posthog-js";
import { addHydrationDiagnostics } from "./hydration-diagnostics";

// Public project token (client-side ingestion only, not a secret API key).
const POSTHOG_PROJECT_TOKEN = "phc_qXu2cReke8ZFUfrY6iJxyqAiJAW3acyyGL2yFcJ2FqyY";
const POSTHOG_API_HOST = "https://us.i.posthog.com";

// Analytics run only on the Vercel production deployment, never on preview
// deployments or local/agent sessions.
export function isPostHogEnabled() {
  return process.env.NEXT_PUBLIC_VERCEL_ENV === "production";
}

export function initPostHog() {
  if (typeof window === "undefined" || !isPostHogEnabled()) return;

  posthog.init(POSTHOG_PROJECT_TOKEN, {
    api_host: POSTHOG_API_HOST,
    defaults: "2026-08-30",
    person_profiles: "identified_only",
    // Approved collection scope: autocapture, pageviews, session replay, and
    // exception capture. Replay keeps PostHog's default input masking.
    disable_session_recording: false,
    capture_exceptions: true,
    // Enrich existing #418 events only. No additional events, text, or replay.
    before_send: addHydrationDiagnostics,
  });
}

// Identify by WorkOS user ID only; no email, name, or other person properties.
export function identifyPostHogUser(workOSUserId: string | undefined) {
  if (!workOSUserId || !isPostHogEnabled() || !posthog.__loaded) return;
  if (posthog.get_distinct_id() === workOSUserId) return;
  posthog.identify(workOSUserId);
}

export function resetPostHogUser() {
  if (!isPostHogEnabled() || !posthog.__loaded) return;
  posthog.reset();
}
